<template>
  <div class="col-xs-12">
    <steps :filled-steps="filledSteps" />
    <h2 class="title-2 text-center partner-title">
      Shipping, Notifications, and Terms
    </h2>

    <form @submit.prevent="handleSubmit" class="form-container" novalidate>
      <p class="paragraph">
        In the event that your submission is awarded, where whould you like them shipped?
        (Personal/School)
        <button class="font-button" @click="handleAwardedAlert">
          <i class="fal fa-question-circle" />
        </button>
      </p>

      <div class="error-alert" v-if="bandShowAwardedAlert">
        <p>
          If awarded, we will send a shipping confirmation email to you to verify we have the correct
          address before sending your supplies.
        </p>
      </div>

      <select
        v-model="form.whereToShip"
        class="input-field"
        @change="$v.form.whereToShip.$touch()"
        required
      >
        <option :value="null">Choose an option</option>
        <option value="personal">Personal</option>
        <option value="school">School</option>
      </select>

      <transition name="fade">
        <div class="subalert">
          <warning-alert v-if="$v.form.whereToShip.$error">
            This field is required
          </warning-alert>
        </div>
      </transition>

      <p class="paragraph">
        Sign me up for marketing and event notifications from KINF
      </p>
      <div class="d-block">
        <div class="input-radio">
          <input type="radio" :value="true" v-model="form.marketingAndEvent">
          <span>Yes</span>
        </div>
        <div class="input-radio">
          <input type="radio" :value="false" v-model="form.marketingAndEvent">
          <span>No</span>
        </div>
      </div>

      <p class="paragraph">
        By clicking yes, I agree to the terms set forth:
      </p>
      <div class="d-block">
        <div class="input-radio">
          <input type="radio" :value="true" v-model="form.agreedTerms">
          <span>Yes</span>
          <span class="inner-circle" :class="{ 'filled-background': form.agreedTerms }"></span>
        </div>
        <div class="input-radio">
          <input type="radio" :value="false" v-model="form.agreedTerms">
          <span>No</span>
          <span class="inner-circle" :class="{ 'filled-background': !form.agreedTerms }"></span>
        </div>

        <transition name="fade">
          <div class="subalert">
            <warning-alert v-if="$v.form.$anyDirty && !form.agreedTerms">
              You need to agree to continue
            </warning-alert>
          </div>
        </transition>
      </div>

      <div class="error-alert mb-4">
        <p>
          All information I am submitting in this application is accurate to the best of my knowledge.
          I understand that if any of the information submitted in this application changes, whether
          while at the same school of I change schools, I will need to update my profile and may
          need to re-qualify.
        </p>
        <br />

        <p>
          If awarded, I agree to distribute all supplies I receive to underserved students in a learning
          enviroment. I will not sell or use the supplies in any manner outside of the intended
          purpose. In the event I have a change in role or school and no longer qualify or fail to
          update my profile, I understand the award will be absorbed back into the program.
        </p>
        <br>

        <p>
          I will send KINF a picture of myself and the supplies I receive (and with students, if
          permitted). I understand that KINF will be sharing details of my submission with potential
          donors in an effort to fund my submission request. Additionally, I understand the KINF may
          use pictures and donation details in promotional materials such as social media
          accounts, email campaigns, and other KINF-related related materials, as needed.
        </p>
        <br />
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-6 mb-3">
          <a href="/teachers/information/personal-impact-statement" class="btn btn-teacher-form btn-previous" :disabled="isSubmitting">
            PREVIOUS
          </a>
        </div>
        <div class="col-xs-12 col-sm-6 mb-3">
          <button type="submit" class="btn btn-teacher-form" :disabled="isSubmitting">
            <span v-show="!isSubmitting">
              SUBMIT
            </span>
            <span v-show="isSubmitting">
              <i class="fas fa-spin fa-spinner" />
              PROCESSING
            </span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Steps from './Steps.vue'
import { required } from 'vuelidate/lib/validators'
// import { waitingAlert } from '../../../utils/alerts'
import TeacherService from '../../../services/TeacherService'
import WarningAlert from '../components/WarningAlert'

// @ts-check
export default {
  name: 'TeachersShippingForm',
  props: {
    teacher: Object,
    filledSteps: Array
  },
  components: {
    Steps,
    WarningAlert
  },
  data () {
    return {
      bandShowAwardedAlert: false,
      form: {
        whereToShip: null,
        marketingAndEvent: true,
        agreedTerms: false
      },
      isSubmitting: false
    }
  },
  methods: {
    handleAwardedAlert () {
      this.bandShowAwardedAlert = !this.bandShowAwardedAlert
    },
    async handleSubmit () {
      this.touchForm()

      if (!this.$v.form.$anyError && this.$v.form.$anyDirty && !this.isSubmitting && this.form.agreedTerms) {
        this.isSubmitting = true
        const service = new TeacherService()
        await service.save(this.form, '/teachers/submitForm')
      }
    },
    touchForm () {
      this.$v.form.whereToShip.$touch()
      // this.$v.form.agreedTerms.$touch()
    }
  },
  validations: {
    form: {
      whereToShip: { required },
      agreedTerms: { required }
    }
  }
}
</script>

<style lang="scss" scoped>
.partner-title {
  color: #6D6E71;
  font-size: 30px;
  margin-bottom: 45px;
}

.form-container {
  max-width: 750px;
  margin: 0 auto;

  .paragraph {
    font-weight: 300;
    font-family: 'Rubik';
    color: #6D6E71;
    line-height: 22px;
    font-size: 18px;
    margin-bottom: 15px;
  }

  .font-button {
    background-color: transparent;
    color: #6D6E71;
    margin-left: 30px;
  }

  .input-field {
    font-weight: 300;
    font-size: 16px;
    font-family: 'Rubik';
    background-color: #F0F0F0;
    border-color: #6D6E71;
    border-width: 1px;
    margin-bottom: 15px;

    @media (min-width: 992px) {
      max-width: 50%;
    }
  }

  .d-block {
    margin-bottom: 25px;
    display: block;
  }

  .input-radio {
    display: inline;
    margin-right: 45px;
    font-family: 'Rubik';
    font-weight: 400;
    font-size: 18px;
    color: #6d6e71;
    position: relative;
  }

  input[type=radio] {
    margin: 0 auto;
    border: 4px solid #6D6E71;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    transition: all ease .2s;

    &:hover {
      cursor: pointer;
    }

    &:checked {
      background-color: #FE8304;
      box-shadow: inset 0px 0px 0px 3px white;
      border: 4px solid #FE8304;
    }
  }
}

.error-alert {
  padding: 1rem;
  background-color: #FFF4E5;
  border: 1px solid #DDC5A4;
  border-radius: 15px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;

  p {
    font-size: 16px !important;
    color: #663C00 !important;
    font-weight: 300 !important;
    font-family: 'Rubik' !important;
  }
}

.subalert {
  @media(min-width: 992px) {
    max-width: 375px;
  }
}

.btn-teacher-form {
  width: 100%;
  max-width: 410px;
  margin: 0 auto;
  display: block;
  padding: .75rem;
  border: 2px solid #FD8204;
  color: #FD8204;
  font-size: 20px;
  font-weight: 500;
  background-color: #FFF;
  border-radius: 10px;
  transition: all ease .2s;

  &:disabled {
    background-color: lighten(#6D6E71, 50%);
  }
}

.btn-previous {
  border-color: #999999;
  color: #999999;
}

.mb-4 {
  margin-bottom: 2rem;
}

// .inner-circle {
//   display: block;
//   width: 8px;
//   height: 8px;
//   background: transparent;
//   border-radius: 10px;
//   position: absolute;
//   top: 2.5px;
//   left: 7px;
//   z-index: -99;
//   transition: all ease .2s;
// }

.filled-background {
  background: #FE8304;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/TeachersForm/Forms/ShippingForm.vue